<template>
    <div class="editor-box">
        <cardCompanyEditor v-if="saveFlag" :companyObj="companyObj" @save-success="saveCallback" />
    </div>
</template>

<script setup>
    import cardCompanyEditor from "@/components/shopopee/card/cardCompanyEditor"
    import eshopopeeApi from "@/request/eshopopeeApi";
    import userApi from "@/request/userApi";
    import companyApi from "@/request/companyApi";
    import {getCurrentInstance, toRef, onMounted, ref} from "vue";
    import {useUserinfo} from "@/stores/userinfo";
    import myUtil from "@/util/util";

    const userinfoRef = toRef(useUserinfo())

    const props = defineProps(["companyObj"])
    const emits = defineEmits(["save-complete"])
    const { proxy } = getCurrentInstance();

    const saveFlag = ref(false)

    let requestCount = 0

    function activate3DShop(){
        const request = eshopopeeApi.openShop
        const params = request.getParams()

        params.login = userinfoRef.value.businessLogin
        params.password = userinfoRef.value.businessPassword
        params.countrycode = null == props.companyObj.countrycode ? userinfoRef.value.country : props.companyObj.countrycode
        params.Curr = props.companyObj.currcode
        params.proxypay = props.companyObj.proxypay

        request.send(params, (res) => {
            if (res.code == 200){
                let acccode = res.companyCode

                acccode = acccode.split(",")

                for (let i=0; i<acccode.length; i++){
                    const c = acccode[i]

                    if (myUtil.isNotEmpty(c)){
                        acccode = c
                        break
                    }
                }


                giveGiftForNew(props.companyObj.companycode)

                updateAddinfo7()

                updateAcccode(props.companyObj.id, acccode)

            }
        })

    }

    function updateAddinfo7(){
        const request = userApi.updateAddinfo7
        const params = request.getParams()

        params.login = userinfoRef.value.businessLogin
        params.addinfo7 = proxy.$EShopopeeUrl
        params.companycode = props.companyObj.companycode

        request.send(params, (res) => {
            addCount()
        })

    }

    function updateAcccode(companyid, acccode){
        const request = companyApi.updateCompanyAcccompanycode
        const params = request.getParams()

        params.id = companyid
        params.acccompanycode = acccode

        request.send(params, (res) => {
            addCount()
        })

    }

    function giveGiftForNew(companycode){
        const request = companyApi.insertGiftBoForNew
        const params = request.getParams()

        params.addinfo3 = userinfoRef.value.login
        params.companycode = companycode
        params.name = userinfoRef.value.name
        params.telephone = userinfoRef.value.telephone

        request.send(params, () => {
            addCount()
        })

    }

    function syncEshopopeeData(){

        const request = companyApi.syncEShopopeeDataByCompanycode
        const params = request.getParams()

        params.companycode = props.companyObj.companycode

        request.send(params, (res) => {
            addCount()
        })

    }

    function addCount(){
        requestCount += 1

        if (requestCount >= 4){
            saveFlag.value = true
        }else if(requestCount === 3){
            syncEshopopeeData()
        }
    }

    function saveCallback(){
        saveFlag.value = false
        emits("save-complete")
    }

    onMounted(() => {
        if (null != props.companyObj){
            activate3DShop()
        }
    })
</script>

<style scoped>
    .editor-box {
        height: 0;
        overflow: hidden;
        position: relative;
    }
</style>